export const API_URL = process.env.VUE_APP_API_URL;
export const CLIENT_ID = process.env.VUE_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.VUE_APP_CLIENT_SECRET;
export const REDIRECT_URI = process.env.VUE_APP_REDIRECT_URI;
export const SCOPE = [];
export const SSO_URL = process.env.VUE_APP_SSO_URL;
export const APP_URL = process.env.VUE_APP_MAIN_URL;
